import {api} from '../../utils/api'

export default {

    /**
     * load fields
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadFields({commit}, taskID) {
        return api.call(commit, 'get', '/api/fields/' + taskID, null, 'SET_FIELDS');
    },

    /**
     * load template results
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadTemplateResults({commit}, taskID) {
        return api.call(commit, 'get', '/api/fields/results/' + taskID);
    },

    /**
     * set template results
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setTemplateResults({commit}, payload) {
        return api.call(commit, 'post', '/api/fields/results/set/' + payload.id, payload);
    },

    /**
     * Update field
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    updateField({commit}, payload) {
        return api.call(commit, 'patch', '/api/fields/' + payload.id, payload, 'SET_FIELDS');
    },

    /**
     * Save fields
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    saveFields({commit}, payload) {
        return api.call(commit, 'post', '/api/fields/instance/'+payload.task_id+'/save', payload, 'SET_FIELDS');
    },

    /**
     * Delete field
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    deleteField({commit}, payload) {
        return api.call(commit, 'delete', '/api/fields/' + payload.id, null, 'DELETE_FIELDS');
    },

    /**
     * create new task field
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    createField({commit}, payload) {
        // Create new field
        return api.call(commit, 'post', '/api/fields/', payload, 'SET_FIELDS');
    },


}
